import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import { Link } from "react-router-dom";
import classes from "./MainNavigation.module.css";
import { CartContext } from "../components/CartContext";
import { useContext, useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../index";

function MainNavigation() {
	const products = useContext(CartContext);
	const products_length = products.cartItems.length;

	// state for loaded categories
	const [categories, setCategories] = useState([]);

	//state for checkiing if mouse is hovering over dropdown
	const [hover, setHover] = useState(false);

	useEffect(() => {
		const loadCategories = async () => {
			const categories = [];
			const category_ref = collection(db, "categories");
			const loadedCategories = await getDocs(category_ref);
			loadedCategories.forEach((category) =>
				categories.push({ id: category.id, ...category.data() })
			);
			setCategories(categories);
		};
		loadCategories();
	}, []);

	return (
		<Navbar expand="lg" className={classes.menuBar}>
			<Container>
				<div className={classes.brandContainer}>
					<Navbar.Brand className={classes.brand}>
						DC Wears
						<div className={classes.brandImgContainer}>
							<img
								src="/images/dcwears.png"
								width="60"
								height="90"
								alt="dcwears"
							/>
						</div>
					</Navbar.Brand>
				</div>

				<Navbar.Toggle
					aria-controls="menu-bar"
					className={classes.toggle}
				/>
				<Navbar.Collapse className="justify-content-end">
					<Nav>
						<Nav.Link as={Link} to="/" className={classes.links}>
							Home
						</Nav.Link>

						<div
							className={classes.categoryContainer}
							onMouseEnter={() => setHover(true)}
							onMouseLeave={() => setHover(false)}
						>
							<p className={classes.categoryText}>Categories</p>

							<div className={classes.imgDropdown}>
								<img
									src="/images/dropdown.png"
									alt="dropdown"
									width={30}
									height={30}
								/>
							</div>
							{hover && (
								<>
									<div className={classes.categoryArrow} />
									<div className={classes.eachCategory}>
										<ul>
											<li>
												<Link to={"/products"}>
													All Categories
												</Link>
											</li>

											{categories.map((category) => (
												<li key={category.id}>
													<Link
														to={
															"/category/" +
															category.id
														}
													>
														{category.name}
													</Link>
												</li>
											))}
										</ul>
									</div>
								</>
							)}
						</div>

						<Nav.Link
							as={Link}
							to="/cart"
							className={classes.links}
						>
							<div className={classes.cartContainer}>
								Cart
								<div className={classes.badgeContainer}>
									<img
										src="/images/cart.png"
										alt="shopping cart"
									/>
									{products_length !== 0 && (
										<span
											className={classes.badge}
										>{`${products_length}`}</span>
									)}
								</div>
							</div>
						</Nav.Link>

						<Nav.Link
							as={Link}
							to="/about"
							className={classes.links}
						>
							About
						</Nav.Link>
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	);
}
export default MainNavigation;
